<template>
  <div id="app">
    <div class="top_main">
      <!-- <img src="../assets/pc/bg.png" alt class="bg" /> -->
      <img src="../assets/pc/new/logo.png" alt class="pos logo" />
      <transition name="bounce">
        <img src="../assets/pc/new/slogan.png" alt class="pos slogan" v-if="aniShow" />
      </transition>
      <img src="../assets/pc/new/fire.gif" alt class="pos fire" width="100%" />
      <video src="../assets/pc/new/video.mp4" autoplay loop muted width="100%" poster="../assets/pc/new/video_bg.png">您的浏览器不支持 video 标签。</video>
      <div class="mask_video"></div>
      <div class="fun_dom">
        <!-- <a href="https://3kd.hermesgames.com.tw/" target="_blank" class="goIndex"></a> -->
        <div class="goDownload" @click="downloadFn"></div>
        <!-- <div class="goRegister" @click="openRegister"></div> -->
      </div>
      <div class="footer">
        <img src="../assets/pc/new/footer.png" alt />
        <ul>
          <a href="https://www.hermesgames.com.tw/#/customerCenter?type=companyInfo" target="_blank">
            <li></li>
          </a>
          <a href="https://www.hermesgames.com.tw/#/customerCenter?type=contactUs" target="_blank">
            <li></li>
          </a>
          <a href="https://www.hermesgames.com.tw/#/customerCenter?type=serviceTerms" target="_blank">
            <li></li>
          </a>
          <a href="https://www.hermesgames.com.tw/#/customerCenter?type=privacyPolicy" target="_blank">
            <li></li>
          </a>
        </ul>
      </div>
      <div class="popup" v-if="clickDownload">
        <img src="../assets/pc/tanchuang.png" alt="">
        <span class="cancel" @click="closePop"></span>
        <span class="determine" @click="closePop"></span>
      </div>
      <div class="mask" v-if="startDownload" @click="closeMask"></div>
      <div class="downloadGif" v-if="startDownload">
        <img src="../assets/pc/download.gif" alt="">
      </div>
    </div>
    <!-- <div class="pic_main pcMain" ref="pic_big">
      <img src="../assets/pc/mainbg.png" alt class="bg" />
      <div class="main_dom">
        <div class="register_else" v-if="registerSuccess">
          <span>{{userInfo.account}}</span>
        </div>
        <div class="register" v-else>
          <div class="register_dom account">
            <input type="text" class placeholder="帳號限6-18字元" maxlength="18" @blur="regx(1)" v-model="userInfo.account" />
            <div class="error_" v-if="rules.account">请正確輸入賬號</div>
          </div>
          <div class="register_dom password">
            <input type="password" class placeholder="密碼限6-18字元" maxlength="18" @blur="regx(2)" v-model="userInfo.password" />
            <div class="error_" v-if="rules.password">请正確輸入密碼</div>
          </div>
          <div class="register_dom password_again">
            <input type="password" class maxlength="18" @blur="regx(3)" placeholder="密碼區分大小寫" v-model="userInfo.passwordAgain" />
            <div class="error_" v-if="rules.passwordAgain">兩次密碼不一致</div>
          </div>
          <div class="register_dom email">
            <input type="text" class @blur="regx(4)" placeholder="電子郵箱以便找回密碼" v-model="userInfo.email" />
            <div class="error_" v-if="rules.email">请正確輸入郵箱</div>
          </div>
          <div class="register_dom code">
            <input type="text" v-model="userInfo.code" />
            <img :src="captcha.image" class="capImage" v-show="captcha.key != ''" @click="drawCode" alt />
          </div>
          <div class="agree" :class="agreeRule ? 'agreed' : ''">
            <div class="agreed_box" @click="agreeRules"></div>
            <a href="https://www.hermesgames.com.tw/#/customerCenter" target="_blank">
              <div class="user_agreed"></div>
            </a>
          </div>
          <div class="btn" @click="registerFn"></div>
        </div>
        <div class="downloadgift">
          <div class="btn" @click="downloadFn"></div>
        </div>
        <div class="seventDay">
          <div class="btn" @click="openGames"></div>
        </div>
      </div>
      <div class="pic_dom" v-if="pic_show">
        <div class="pic_big">
          <transition enter-active-class="animate__animated animate__fadeIn">
            <div class="pic_big_" v-if="pic == 1">
              <img src="../assets/pc/gamepic/campsBig.png" alt />
            </div>
          </transition>
          <transition enter-active-class="animate__animated animate__fadeIn">
            <div class="pic_big_" v-if="pic == 2">
              <img src="../assets/pc/gamepic/daynightBig.png" alt />
            </div>
          </transition>
          <transition enter-active-class="animate__animated animate__fadeIn">
            <div class="pic_big_" v-if="pic == 3">
              <img src="../assets/pc/gamepic/groupBig.png" alt />
            </div>
          </transition>
          <transition enter-active-class="animate__animated animate__fadeIn">
            <div class="pic_big_" v-if="pic == 4">
              <img src="../assets/pc/gamepic/militaryBig.png" alt />
            </div>
          </transition>
          <transition enter-active-class="animate__animated animate__fadeIn">
            <div class="pic_big_" v-if="pic == 5">
              <img src="../assets/pc/gamepic/manorBig.png" alt />
            </div>
          </transition>
        </div>
        <div class="pic_small">
          <div class="pic_small_" :class="pic == 1 ? 'active' : ''" @mouseover="showBig(1)">
            <img src="../assets/pc/gamepic/camps.png" alt />
          </div>
          <div class="pic_small_" :class="pic == 2 ? 'active' : ''" @mouseover="showBig(2)">
            <img src="../assets/pc/gamepic/daynight.png" alt />
          </div>
          <div class="pic_small_" :class="pic == 3 ? 'active' : ''" @mouseover="showBig(3)">
            <img src="../assets/pc/gamepic/group.png" alt />
          </div>
          <div class="pic_small_" :class="pic == 4 ? 'active' : ''" @mouseover="showBig(4)">
            <img src="../assets/pc/gamepic/military.png" alt />
          </div>
          <div class="pic_small_" :class="pic == 5 ? 'active' : ''" @mouseover="showBig(5)">
            <img src="../assets/pc/gamepic/manor.png" alt />
          </div>
        </div>
      </div>
      <div class="footer">
        <img src="../assets/pc/footer.png" alt />
        <ul>
          <a href="https://www.hermesgames.com.tw/#/customerCenter?id=companyInfo" target="_blank">
            <li></li>
          </a>
          <a href="https://www.hermesgames.com.tw/#/customerCenter?id=2" target="_blank">
            <li></li>
          </a>
          <a href="https://www.hermesgames.com.tw/#/customerCenter?id=4" target="_blank">
            <li></li>
          </a>
          <a href="https://www.hermesgames.com.tw/#/customerCenter?id=3" target="_blank">
            <li></li>
          </a>
        </ul>
      </div>
    </div>-->
    <div class="mark" v-if="downloadFirst || openGame || registerLayer">
      <!-- <div class="dando" v-if="registerSuccess">
        <img src="../assets/pc/x.png" @click="closedando" alt class="close" />
        <img src="../assets/pc/success .png" alt class="ctx" />
      </div>-->
      <div class="dlf" v-if="downloadFirst">
        <img src="../assets/pc/x.png" @click="closedando" alt class="close" />
        <img src="../assets/pc/downloadFirst.png" alt class="ctx" />
        <img src="../assets/pc/sure.png" @click="closedando" alt class="sure" />
      </div>
      <div class="og" v-if="openGame">
        <img src="../assets/pc/x.png" @click="closedando" alt class="close" />
        <img src="../assets/pc/openGame.png" alt class="ctx" />
        <img src="../assets/pc/sure.png" @click="closedando" alt class="sure" />
      </div>
      <register v-if="registerLayer" @closedando="closedandos" @openSuccess="openSuccess"></register>
    </div>
  </div>
</template>

<script>
import Register from './register.vue'
export default {
  name: 'App',
  components: { Register },
  data() {
    return {
      pic: 1,
      pic_show: true,
      fb_show: false,
      vd_show: false,
      video_in: 0,
      v_control: 0,
      transfromX: 0,
      listInArray: [],
      play_in: 0,
      play_btn: 0,
      tabpages: { pages: 100, pageNum: 1 },
      urlList: { ios_url: '', fb_fans_url: '', apk_url: '', android_url: '' },
      openGame: false,
      downloadFirst: false,
      registerSuccess: false,
      registerLayer: false,
      downloadStatus: false,
      userInfo: {
        account: '',
        password: '',
        passwordAgain: '',
        email: '',
        code: '',
      },
      rules: {
        account: false,
        password: false,
        passwordAgain: false,
        email: false,
        code: false,
      },
      show_num: [],
      agreeRule: false,
      switchs: true,
      captcha: {
        image: '',
        key: '',
      },
      aniShow: false,
      aniShow_fire: false,
      clickDownload: false,
      startDownload: false
    }
  },
  mounted: function () {
    this.aniShow = true
    this.aniShow_fire = true
    // let that = this
    // this.listInArray = [0, 3]
    // var show_num = this.show_num
    // this.getCaptcha()
  },
  watch: {},
  methods: {
    init_video: function () {
      let that = this
      let dom = document.getElementById('videos')

      dom.addEventListener('pause', function () {
        that.play_btn = 0
      })
      dom.addEventListener('play', function () {
        that.play_btn = 1
      })
      dom.addEventListener('end', function () {
        that.play_btn = 0
      })
    },
    get_item: function () {
      let dom = document.querySelector('.pic_item')
      let width, marginRight
      if (window.getComputedStyle) {
        width = window.getComputedStyle(dom, null).width
        marginRight = window.getComputedStyle(dom, null).marginRight
      } else {
        width = dom.currentStyle.width
        marginRight = dom.currentStyle.marginRight
      }
      return (
        Number(width.substring(0, width.length - 2)) +
        Number(marginRight.substring(0, marginRight.length - 2))
      )
    },
    showBig: function (e) {
      this.pic = e
    },
    closedando: function (e) {
      // this.registerSuccess = false
      this.downloadFirst = false
      this.openGame = false
      this.registerLayer = false
    },
    closedandos: function () {
      this.registerLayer = false
    },
    openSuccess() {
      this.registerSuccess = true
    },
    openDownload() {
      this.downloadFirst = true
    },
    openGames() {
      if (this.downloadStatus) {
        this.openGame = true
      } else {
        this.downloadFirst = true
      }
    },
    openRegister() {
      // this.registerLayer = true;
      let regHeight = this.$refs['pic_big'].offsetTop
      window.scrollTo({
        top: regHeight,
        behavior: 'smooth',
      })
    },
    draw(show_num) {
      var canvas_width = 80
      var canvas_height = 30
      var canvas = document.getElementById('canvas') //获取到canvas的对象，演员
      var context = canvas.getContext('2d') //获取到canvas画图的环境，演员表演的舞台
      canvas.width = canvas_width
      canvas.height = canvas_height
      var sCode =
        'a,b,c,d,e,f,g,h,i,j,k,m,n,p,q,r,s,t,u,v,w,x,y,z,A,B,C,E,F,G,H,J,K,L,M,N,P,Q,R,S,T,W,X,Y,Z,1,2,3,4,5,6,7,8,9,0'
      var aCode = sCode.split(',')
      var aLength = aCode.length //获取到数组的长度
      for (var i = 0; i < 4; i++) {
        //这里的for循环可以控制验证码位数（如果想显示6位数，4改成6即可）
        var j = Math.floor(Math.random() * aLength) //获取到随机的索引值
        // var deg = Math.random() * 30 * Math.PI / 180;//产生0~30之间的随机弧度
        var deg = Math.random() - 0.5 //产生一个随机弧度
        var txt = aCode[j] //得到随机的一个内容
        show_num[i] = txt.toLowerCase()
        var x = 5 + i * 16 //文字在canvas上的x坐标
        var y = 20 + Math.random() * 8 //文字在canvas上的y坐标
        context.font = 'bold 23px 微软雅黑'
        context.translate(x, y)
        context.rotate(deg)
        context.fillStyle = this.randomColor()
        context.fillText(txt, 0, 0)
        context.rotate(-deg)
        context.translate(-x, -y)
      }
      for (var i = 0; i <= 5; i++) {
        //验证码上显示线条
        context.strokeStyle = this.randomColor()
        context.beginPath()
        context.moveTo(
          Math.random() * canvas_width,
          Math.random() * canvas_height
        )
        context.lineTo(
          Math.random() * canvas_width,
          Math.random() * canvas_height
        )
        context.stroke()
      }
      for (var i = 0; i <= 30; i++) {
        //验证码上显示小点
        context.strokeStyle = this.randomColor()
        context.beginPath()
        var x = Math.random() * canvas_width
        var y = Math.random() * canvas_height
        context.moveTo(x, y)
        context.lineTo(x + 1, y + 1)
        context.stroke()
      }
    },
    randomColor() {
      var r = Math.floor(Math.random() * 256)
      var g = Math.floor(Math.random() * 256)
      var b = Math.floor(Math.random() * 256)
      return 'rgb(' + r + ',' + g + ',' + b + ')'
    },
    drawCode() {
      this.getCaptcha()
    },
    agreeRules() {
      this.agreeRule = !this.agreeRule
    },
    regx(e) {
      if (e == 1) {
        if (this.userInfo.account.length < 6) {
          this.rules.account = true
        } else {
          this.rules.account = false
        }
      }
      if (e == 2) {
        if (this.userInfo.password.length < 6) {
          this.rules.password = true
        } else {
          this.rules.password = false
        }
      }
      if (e == 3) {
        if (this.userInfo.password != this.userInfo.passwordAgain) {
          this.rules.passwordAgain = true
        } else {
          this.rules.passwordAgain = false
        }
      }
      if (e == 4) {
        if (
          /^([a-zA-Z\d])((\w|-)+\.?)+@([a-zA-Z\d]+\.)+[a-zA-Z]{2,6}$/.test(
            this.userInfo.email
          )
        ) {
          this.rules.email = false
        } else {
          this.rules.email = true
        }
      }
    },
    registerFn() {
      if (!this.agreeRule) {
        this.$layer.msg('請勾選接受協議')
        return
      }
      this.regx(1)
      this.regx(2)
      this.regx(3)
      this.regx(4)
      let switchs = false
      for (let i in this.rules) {
        if (this.rules[i]) {
          switchs = true
        }
      }

      if (!switchs) {
        let data = {
          account: this.userInfo.account,
          email: this.userInfo.email,
          password: this.userInfo.password,
          password_confirmation: this.userInfo.passwordAgain,
          captcha: this.userInfo.code,
          key: this.captcha.key,
        }
        this.postHttp(this, data, '/api/v4/register', function (obj, res) {
          if (res.code == 200) {
            obj.registerSuccess = true
            obj.getCaptcha()
          } else {
            obj.getCaptcha()
            obj.$layer.msg(res.message)
          }
        })
      }
    },
    getCaptcha() {
      this.getHttp(this, '', '/api/v4/getCaptcha', function (obj, res) {
        obj.captcha.image = res.image
        obj.captcha.key = res.key
      })
    },
    downloadFn() {
      this.clickDownload = true
      console.log('website gata')
      gtag('event', 'appointment', {
        event_category: 'Download',
        event_label: 'Download_Website',
        value: 1,
      })
      this.downloadStatus = true
      window.open('https://cycdn.gamemorefun.com/newsg/3KD_GW.exe')
      this.startDownload = true
    },
     closePop() {
      this.clickDownload = false
    },
    closeMask() {
      this.startDownload = false
    }
  },
}
</script>

<style lang='scss'>
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
.bounceFire-enter-active {
  animation: bounce-in-fire 0.25s;
}
@keyframes bounce-in-fire {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  width: 100%;
  height: 100%;

  .top_main {
    width: 100%;
    position: relative;
    overflow-x: hidden;
    font-size: 0;
    .footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      z-index: 2;
      bottom: 0;
      img {
        display: block;
        width: 100%;
      }
      ul {
        position: absolute;
        list-style: none;
        top: 50%;
        left: 50%;
        width: 3.2rem;
        height: 0.35rem;
        margin-left: -2.4rem;
        margin-top: 0.4rem;
        padding: 0;
        a {
          display: block;
        }
        li {
          float: left;
          width: 0.8rem;
          height: 0.5rem;
        }
      }
    }
    .pos {
      position: absolute;
      z-index: 2;
      left: 50%;
      top: 50%;
    }
    .logo {
      width: 3.45rem;
      height: 1.89rem;
      top: 0.25rem;
    }
    .fire {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
    .slogan {
      width: 11.34rem;
      height: 1.31rem;
      top: 3.72rem;
      margin-left: -5.67rem;
    }
    .mask_video {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      background: url('../assets/pc/new/m2.png') no-repeat;
      background-size: 100% 100%;
    }
    .bg {
      width: 100%;
      display: block;
    }
    .logo {
      position: absolute;
      width: 3.4rem;
      top: 0.3rem;
      left: 50%;
      margin-left: -8rem;
    }
    .fun_dom {
      width: 3.35rem;
      height: 0.98rem;
      position: absolute;
      top: 5.24rem;
      left: 50%;
      z-index: 2;
      margin-left: -1.675rem;
      background: url('../assets/pc/new/btn_war.png') no-repeat;
      background-size: 100% 100%;
      justify-content: space-around;
      align-items: center;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        transform: scale(1.1);
      }
      .goIndex {
        width: 2.45rem;
        height: 100%;
      }
      .goDownload {
        width: 4.62rem;
        height: 100%;
      }
      .goRegister {
        width: 2.45rem;
        height: 100%;
      }
    }
    .godown {
      position: absolute;
      width: 0.37rem;
      top: 50%;
      margin-top: 3.8rem;
      left: 50%;
      margin-left: -0.2rem;
    }
  }
  .main_dom {
    width: 12rem;
    height: 5rem;
    position: absolute;
    top: 1.8rem;
    left: 50%;
    margin-left: -6rem;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    .btn {
      position: absolute;
      width: 1.6rem;
      height: 0.4rem;
      cursor: pointer;
      top: 3.85rem;
      left: 50%;
      margin-left: -0.8rem;
    }
    .register_else {
      width: 3.1rem;
      height: 4.83rem;
      background: url('../assets/pc/register_else.png') no-repeat;
      background-size: 100% 100%;
      position: relative;
      span {
        color: #362310;
        font-size: 0.22rem;
        position: absolute;
        display: block;
        width: 2.4rem;
        top: 2.1rem;
        left: 50%;
        margin-left: -1.2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        font-family: '楷体';
      }
    }
    .register {
      width: 3.1rem;
      height: 4.83rem;
      background: url('../assets/pc/register.png') no-repeat;
      background-size: 100% 100%;
      position: relative;
      .register_dom {
        position: absolute;
        width: 1.6rem;
        height: 0.5rem;
        top: 0.95rem;
        left: 50%;
        margin-left: -0.3rem;
        input {
          width: 1.4rem;
          height: 0.3rem;
          line-height: 0.3rem;
          border: 0;
          outline: 0;
          padding: 0 5px;
          font-size: 0.14rem;
          color: #ba9e5a;
          display: block;
        }
        .error_ {
          font-size: 0.12rem;
          color: red;
          width: 100%;
          left: 0;
          bottom: 0;
        }
      }
      .password {
        top: 1.45rem;
      }
      .password_again {
        top: 1.95rem;
      }
      .email {
        top: 2.45rem;
      }
      .code {
        top: 2.95rem;
        input {
          width: 0.6rem;
        }
        .capImage {
          width: 0.7rem;
          height: 0.3rem;
          display: block;
          position: absolute;
          top: 0;
          right: 0.1rem;
          cursor: pointer;
        }
        #canvas,
        .canvasDown,
        .canvasUp {
          position: absolute;
          right: 0;
          top: 0;
          width: 80px;
          height: 30px;
          z-index: 2;
        }
        .canvasDown {
          z-index: 1;
          background-color: white;
        }
        .canvasUp {
          z-index: 3;
          cursor: pointer;
        }
      }
      .agree {
        width: 2.46rem;
        height: 0.33rem;
        background: url('../assets/pc/rule.png') no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 3.4rem;
        left: 0.3rem;
        .agreed_box {
          width: 0.3rem;
          height: 0.3rem;
          position: absolute;
          top: 0;
          left: 0;
          cursor: pointer;
        }
        .user_agreed {
          width: 1rem;
          height: 0.3rem;
          position: absolute;
          top: 0;
          right: 0;
          cursor: pointer;
        }
      }
      .agreed {
        background: url('../assets/pc/ruled.png') no-repeat;
        background-size: 100% 100%;
      }
    }
    .downloadgift {
      width: 3.37rem;
      height: 4.83rem;
      background: url('../assets/pc/downloadGift.png') no-repeat;
      background-size: 100% 100%;
      position: relative;
    }
    .seventDay {
      width: 3.1rem;
      height: 4.83rem;
      background: url('../assets/pc/seventDay.png') no-repeat;
      background-size: 100% 100%;
      position: relative;
    }
  }
  .pic_main {
    width: 100%;
    position: relative;
    overflow: hidden;
    margin-top: -1.8rem;
    .bg {
      width: 100%;
      display: block;
    }
    .title {
      width: 19rem;
      position: absolute;
      top: 0;
      left: 0;
    }
    .pic_dom {
      width: 13.25rem;
      top: 50%;
      margin-top: -1.6rem;
      left: 50%;
      margin-left: -6.625rem;
      position: absolute;
      img {
        display: block;
      }
      .pic_big {
        width: 100%;
        margin-bottom: 0.5rem;
        height: 4.1rem;
        overflow: hidden;
        .pic_big_ {
          width: 100%;
        }
      }
      .pic_small {
        width: 116%;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-around;
        margin-left: -8%;
        .pic_small_ {
          width: 2.6rem;
          height: 1.465rem;
          cursor: default;
          border: 3px solid rgba(0, 0, 0, 0);
          transition: 0.3s border linear;
        }
        .active {
          border: 3px solid #ba9e5a;
        }
      }
    }
    .small_dom {
      width: 13.25rem;
      top: 50%;
      margin-top: -3.5rem;
      left: 50%;
      margin-left: -6.625rem;
      position: absolute;
    }
  }
  .footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    img {
      display: block;
      width: 100%;
    }
    ul {
      position: absolute;
      list-style: none;
      top: 3.9rem;
      left: 5.7rem;
      width: 6rem;
      margin: 0;
      padding: 0;
      a {
        display: block;
      }
      li {
        float: left;
        width: 0.8rem;
        height: 0.5rem;
      }
    }
  }
  .mark {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 10;
    background-color: rgba(0, 0, 0, 0.7);
    .dando,
    .dlf,
    .og {
      position: absolute;
      top: 50%;
      margin-top: -3.35rem;
      width: 8.03rem;
      height: 6.7rem;
      left: 50%;
      margin-left: -4.015rem;
      background: url('../assets/pc/layerbg.png') no-repeat;
      background-size: 100% 100%;
      .ctx {
        margin: auto;
        width: 6.35rem;
        margin-top: 1.3rem;
        display: block;
      }
      .close {
        position: absolute;
        width: 1rem;
        height: 0.95rem;
        cursor: pointer;
        top: 0.2rem;
        right: 0.2rem;
      }
    }
    .dlf,
    .og {
      height: 3.57rem;
      margin-top: -1.8rem;
      .ctx {
        width: 3.58rem;
      }
      .sure {
        width: 3.18rem;
        cursor: pointer;
        margin: auto;
        display: block;
        margin-top: 0.4rem;
      }
    }
    .og {
      .ctx {
        width: 6.55rem;
      }
    }
  }
}
.popup {
  position:fixed;
  top: 0;
  left:0;
  z-index:3;

}
.popup .cancel {
    position:absolute;
    top: 24%;
    left: 62.5%;
    width: 2%;
    height:3%;
  }
.popup .determine {
 position: absolute;
    top: 57%;
    left: 51%;
    transform: translateX(-50%);
    width: 9%;
    height: 4%;
} 
.mask {
  position:fixed;
  top:0;
  left:0;
  width:100vw;
  height:100vh;
  z-index:4!important;
  background:#000;
  opacity: .7;
}
.downloadGif {
  position:fixed;
  bottom:30px;
  left:50px;
  width:16%;
  z-index:5;
}
</style>
